import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Divider, Typography } from "@material-ui/core";
import { bindHover, bindPopover } from "material-ui-popup-state";
import { usePopupState } from "material-ui-popup-state/hooks";
import { StyledPopover } from "../commonComponents";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    background: `${theme.palette.background.table} !important`,
    borderRadius: 6,
    padding: 10,
    width: "100%",
    "& .item": {
      marginRight: 4,
    },
    "& img": {
      marginBottom: "-2px",
    },
  },
  dot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
  },
  rootPapover: {
    background: `${theme.palette.background.table} !important`,
    padding: 10,
  },
  len: {
    color: "#EC6A49",
    right: 7,
    position: "absolute",
  },
}));

function Allergy(props) {
  const classes = useStyles(props);
  const more = usePopupState({
    variant: "popover",
    popupId: "directions",
  });

  const { icon, list, activeIndex } = props;
  const color = activeIndex?.color;
  const data =
    activeIndex?.value === "All"
      ? list
      : list?.filter((val) => val?.clinicalstatus === activeIndex?.value);

  return (
    <>
      {data?.[0]?.shortdesc ? (
        <div className={classes.root}>
          <img src={icon} alt="icon" />
          <Divider orientation="vertical" variant="middle" flexItem />
          {[data?.[0]]?.map((item, index) => {
            return (
              item?.shortdesc && (
                <Typography noWrap className="item">
                  <label
                    className={classes.dot}
                    style={{ background: color ?? "" }}
                  ></label>{" "}
                  &nbsp;{item?.shortdesc}
                </Typography>
              )
            );
          })}
          &nbsp;
          {data?.length > 0 && (
            <span className={classes.len} {...bindHover(more)}>
              {"+" + data?.length}
            </span>
          )}
        </div>
      ) : (
        "No Allergy"
      )}

      <StyledPopover
        renderHoverPopover
        maxWidth={"550px"}
        {...bindPopover(more)}
      >
        <div className={classes.rootPapover}>
          {data?.map((item, index) => {
            return (
              item?.shortdesc && (
                <Typography noWrap className="item">
                  <label
                    className={classes.dot}
                    style={{ background: color ?? "" }}
                  ></label>{" "}
                  &nbsp;{item?.shortdesc}
                </Typography>
              )
            );
          })}
        </div>
      </StyledPopover>
    </>
  );
}

export default Allergy;
